import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SectionStamp } from '../components/Atoms';
import Icon from '../components/Icon';
import { fonts } from '../theme';

const SERVICES = ['Orthopaedic', 'Neurological', 'Paediatric', 'Geriatric', 'Post-op rehab'];

const DAYS = [
  { d: 12, w: 'Tue', dis: true },
  { d: 13, w: 'Wed', dis: false },
  { d: 14, w: 'Thu', dis: false },
  { d: 15, w: 'Fri', dis: false },
  { d: 16, w: 'Sat', dis: false },
  { d: 17, w: 'Sun', dis: true },
  { d: 18, w: 'Mon', dis: false },
];

const TIMES = ['09:00', '10:30', '12:00', '14:30', '16:00', '17:30'];

export default function Booking({ t }) {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [picked, setPicked] = useState({
    service: 'Orthopaedic',
    where: 'Clinic',
    date: 14,
    time: '10:30',
    name: '', phone: '', notes: '',
  });

  const update = (k, v) => setPicked(p => ({ ...p, [k]: v }));

  return (
    <div style={{
      width: '100%', height: '100%', position: 'relative',
      overflow: 'hidden', background: t.paper, color: t.ink,
    }}>
      <div style={{ padding: '8px 22px 16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 4 }}>
          <button onClick={() => step === 0 ? navigate('/') : setStep(s => s - 1)} style={{
            appearance: 'none', border: 'none', background: 'transparent', cursor: 'pointer',
            color: t.ink, fontFamily: fonts.mono, fontSize: 10,
            letterSpacing: '0.18em', textTransform: 'uppercase',
            display: 'inline-flex', alignItems: 'center', gap: 6,
          }}>
            <Icon name="arrow-left" size={14} stroke={t.ink}/>
            <span>Back</span>
          </button>
          <div style={{
            fontFamily: fonts.mono, fontSize: 10, color: t.muted,
            letterSpacing: '0.18em', textTransform: 'uppercase',
          }}>
            {String(step + 1).padStart(2, '0')} / 04
          </div>
        </div>
        <div style={{ display: 'flex', gap: 4, marginTop: 14 }}>
          {[0, 1, 2, 3].map(i => (
            <div key={i} style={{
              flex: 1, height: 2, borderRadius: 2,
              background: i <= step ? t.ink : t.hair,
              transition: 'background .2s',
            }}/>
          ))}
        </div>
      </div>

      <div style={{
        position: 'absolute', top: 90, left: 0, right: 0, bottom: 0,
        overflowY: 'auto', padding: '0 22px 120px',
      }}>
        {step === 0 && (
          <div>
            <SectionStamp n="01" label="Choose care" t={t} />
            <h1 style={{
              fontFamily: fonts.serif, fontSize: 36, fontWeight: 300,
              letterSpacing: '-0.03em', lineHeight: 1, margin: '14px 0 6px',
            }}>
              What brings <span style={{ fontStyle: 'italic' }}>you</span> in?
            </h1>
            <p style={{
              fontFamily: fonts.sans, fontSize: 12.5, color: t.muted,
              margin: '0 0 22px', lineHeight: 1.5,
            }}>
              Pick the closest match. We&rsquo;ll refine the plan in your first consult.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {SERVICES.map(s => {
                const on = picked.service === s;
                return (
                  <button key={s} onClick={() => update('service', s)} style={{
                    appearance: 'none', textAlign: 'left', cursor: 'pointer',
                    background: on ? t.ink : 'transparent', color: on ? t.paper : t.ink,
                    border: `0.5px solid ${on ? t.ink : t.hair}`,
                    borderRadius: 12, padding: '14px 16px',
                    fontFamily: fonts.sans, fontSize: 14, fontWeight: 500,
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  }}>
                    <span>{s}</span>
                    {on && <Icon name="check" size={16} stroke={t.mint}/>}
                  </button>
                );
              })}
            </div>

            <div style={{ marginTop: 24 }}>
              <SectionStamp n="02" label="Where" t={t} />
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 12 }}>
                {[
                  { id: 'Clinic', sub: 'Vadodara', ic: 'pin' },
                  { id: 'Home', sub: 'Within Vadodara', ic: 'home' },
                ].map(opt => {
                  const on = picked.where === opt.id;
                  return (
                    <button key={opt.id} onClick={() => update('where', opt.id)} style={{
                      appearance: 'none', textAlign: 'left', cursor: 'pointer',
                      background: on ? t.mint : 'transparent', color: t.ink,
                      border: `0.5px solid ${on ? t.mint : t.hair}`,
                      borderRadius: 12, padding: 14,
                    }}>
                      <Icon name={opt.ic} size={18} sw={1.6}/>
                      <div style={{ fontFamily: fonts.serif, fontSize: 18, marginTop: 8 }}>{opt.id}</div>
                      <div style={{
                        fontFamily: fonts.mono, fontSize: 9.5, color: t.muted,
                        letterSpacing: '0.16em', textTransform: 'uppercase', marginTop: 2,
                      }}>{opt.sub}</div>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {step === 1 && (
          <div>
            <SectionStamp n="03" label="Pick a slot" t={t} />
            <h1 style={{
              fontFamily: fonts.serif, fontSize: 36, fontWeight: 300,
              letterSpacing: '-0.03em', lineHeight: 1, margin: '14px 0 22px',
            }}>
              When works <span style={{ fontStyle: 'italic' }}>best?</span>
            </h1>

            <div style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 10,
            }}>
              <div style={{ fontFamily: fonts.sans, fontSize: 13, fontWeight: 600 }}>May 2026</div>
              <div style={{
                fontFamily: fonts.mono, fontSize: 9.5, color: t.muted,
                letterSpacing: '0.16em', textTransform: 'uppercase',
              }}>This week</div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 6 }}>
              {DAYS.map(day => {
                const on = picked.date === day.d;
                return (
                  <button
                    key={day.d}
                    disabled={day.dis}
                    onClick={() => !day.dis && update('date', day.d)}
                    style={{
                      appearance: 'none', cursor: day.dis ? 'not-allowed' : 'pointer',
                      background: on ? t.ink : 'transparent',
                      color: day.dis ? t.muted + '66' : on ? t.paper : t.ink,
                      border: `0.5px solid ${on ? t.ink : t.hair}`,
                      borderRadius: 10, padding: '8px 0', textAlign: 'center',
                    }}
                  >
                    <div style={{
                      fontFamily: fonts.mono, fontSize: 8.5, letterSpacing: '0.12em',
                      textTransform: 'uppercase', opacity: day.dis ? 0.4 : 0.7,
                    }}>{day.w}</div>
                    <div style={{
                      fontFamily: fonts.serif, fontSize: 18, marginTop: 2,
                      textDecoration: day.dis ? 'line-through' : 'none',
                    }}>{day.d}</div>
                  </button>
                );
              })}
            </div>

            <div style={{ marginTop: 24 }}>
              <div style={{
                fontFamily: fonts.mono, fontSize: 9.5, color: t.muted,
                letterSpacing: '0.16em', textTransform: 'uppercase', marginBottom: 10,
              }}>Available times</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 6 }}>
                {TIMES.map(time => {
                  const on = picked.time === time;
                  return (
                    <button key={time} onClick={() => update('time', time)} style={{
                      appearance: 'none', cursor: 'pointer',
                      background: on ? t.mint : 'transparent', color: t.ink,
                      border: `0.5px solid ${on ? t.mint : t.hair}`,
                      borderRadius: 10, padding: '12px 0',
                      fontFamily: fonts.serif, fontSize: 16, fontWeight: 400,
                      letterSpacing: '-0.01em',
                    }}>{time}</button>
                  );
                })}
              </div>
            </div>

            <div style={{
              marginTop: 24, padding: 14, borderRadius: 12,
              background: t.cream, color: t.ink,
              display: 'flex', alignItems: 'center', gap: 12,
            }}>
              <Icon name="clock" size={18} stroke={t.mintDeep}/>
              <div style={{ fontFamily: fonts.sans, fontSize: 11.5, lineHeight: 1.4 }}>
                First consult <strong>45 min</strong> · Follow-ups <strong>30 min</strong>
              </div>
            </div>
          </div>
        )}

        {step === 2 && (
          <div>
            <SectionStamp n="04" label="About you" t={t} />
            <h1 style={{
              fontFamily: fonts.serif, fontSize: 36, fontWeight: 300,
              letterSpacing: '-0.03em', lineHeight: 1, margin: '14px 0 22px',
            }}>
              A few <span style={{ fontStyle: 'italic' }}>details.</span>
            </h1>

            {[
              { k: 'name', label: 'Full name', placeholder: 'Anjali Rao' },
              { k: 'phone', label: 'Phone', placeholder: '+91 ' },
              { k: 'notes', label: 'What hurts? (optional)', placeholder: 'A short note helps me prepare.', multi: true },
            ].map(f => (
              <div key={f.k} style={{ marginBottom: 14 }}>
                <label style={{
                  fontFamily: fonts.mono, fontSize: 9.5, color: t.muted,
                  letterSpacing: '0.16em', textTransform: 'uppercase',
                  display: 'block', marginBottom: 6,
                }}>
                  {f.label}
                </label>
                {f.multi ? (
                  <textarea
                    value={picked[f.k]}
                    onChange={e => update(f.k, e.target.value)}
                    placeholder={f.placeholder}
                    style={{
                      width: '100%', minHeight: 80, padding: 12,
                      background: 'transparent', color: t.ink,
                      border: `0.5px solid ${t.hair}`, borderRadius: 10,
                      fontFamily: fonts.sans, fontSize: 14, resize: 'none', outline: 'none',
                    }}
                  />
                ) : (
                  <input
                    value={picked[f.k]}
                    onChange={e => update(f.k, e.target.value)}
                    placeholder={f.placeholder}
                    style={{
                      width: '100%', padding: 14,
                      background: 'transparent', color: t.ink,
                      border: `0.5px solid ${t.hair}`, borderRadius: 10,
                      fontFamily: fonts.sans, fontSize: 14, outline: 'none',
                    }}
                  />
                )}
              </div>
            ))}
          </div>
        )}

        {step === 3 && (
          <div>
            <div style={{
              width: 64, height: 64, borderRadius: 999, background: t.mint,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '20px 0 18px',
            }}>
              <Icon name="check" size={28} stroke={t.ink} sw={2}/>
            </div>
            <SectionStamp n="✓" label="Confirmed" t={t} />
            <h1 style={{
              fontFamily: fonts.serif, fontSize: 36, fontWeight: 300,
              letterSpacing: '-0.03em', lineHeight: 1, margin: '14px 0 8px',
            }}>
              See you on <span style={{ fontStyle: 'italic' }}>Thursday.</span>
            </h1>
            <p style={{
              fontFamily: fonts.sans, fontSize: 13, color: t.muted, lineHeight: 1.5,
              margin: '0 0 22px',
            }}>
              You&rsquo;ll get a WhatsApp confirmation and a reminder the day before.
            </p>

            <div style={{ borderTop: `0.5px solid ${t.hair}`, paddingTop: 18 }}>
              {[
                ['Care', picked.service],
                ['Where', picked.where + ' · Vadodara'],
                ['When', `Thu, May ${picked.date} · ${picked.time}`],
                ['Duration', '45 min'],
              ].map(([k, v]) => (
                <div key={k} style={{
                  display: 'flex', justifyContent: 'space-between',
                  padding: '12px 0', borderBottom: `0.5px solid ${t.hair}`,
                }}>
                  <span style={{
                    fontFamily: fonts.mono, fontSize: 10, color: t.muted,
                    letterSpacing: '0.16em', textTransform: 'uppercase',
                  }}>{k}</span>
                  <span style={{ fontFamily: fonts.serif, fontSize: 16 }}>{v}</span>
                </div>
              ))}
            </div>

            <button
              onClick={() => { setStep(0); navigate('/'); }}
              style={{
                appearance: 'none', border: `0.5px solid ${t.hair}`, background: 'transparent',
                cursor: 'pointer', width: '100%', padding: 14, marginTop: 20, borderRadius: 12,
                fontFamily: fonts.sans, fontSize: 13, fontWeight: 500, color: t.ink,
              }}
            >Back to home</button>
          </div>
        )}
      </div>

      {step < 3 && (
        <div style={{
          position: 'absolute', left: 0, right: 0, bottom: 0,
          padding: '12px 22px 30px',
          background: `linear-gradient(180deg, transparent, ${t.paper} 30%)`,
        }}>
          <button onClick={() => setStep(s => s + 1)} style={{
            appearance: 'none', border: 'none', cursor: 'pointer',
            background: t.ink, color: t.paper,
            width: '100%', padding: 16, borderRadius: 999,
            fontFamily: fonts.sans, fontSize: 14, fontWeight: 500,
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          }}>
            <span>{step === 0 ? 'Continue' : step === 1 ? `${picked.time} on the ${picked.date}th` : 'Confirm booking'}</span>
            <Icon name="arrow-right" size={16}/>
          </button>
        </div>
      )}
    </div>
  );
}
